import { BrowserRouter, Route, Routes } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import English from "./Pages/English";
import Malayalam from "./Pages/Malayalam";
import CrosswordCreator from "./Pages/CrosswordCreator";
import SignUp from "./Pages/SignUp";
import NewGame1 from "./Pages/NewGame1";
import PlaceAnswerInGrid from "./components/PlaceAnswerInGrid";
import PlayerSignUp from "./Pages/PlayerSignUp";
import CreatorSignUp from "./Pages/GameCreatorSignUp";
import Landing from "./Pages/Landing";
import PlayerSignIn from "./Pages/PlayerSignIn";
import CreatorSignIn from "./Pages/GameCreatorSignIn";
import PlayGame from "./Pages/game";
import CreatorLanding from "./Pages/CreatorLanding";
import NotRelese from "./Pages/NotRelease";
import CreatorPlayGame from "./Pages/CreatorPlayGame";
import SnowingEffect from "./components/Snowpopup";
import Theme from "./Pages/Theme";
import GameName from "./Pages/GameName";
import PlayerLanding from "./Pages/PlayerLanding";
import PlayerChangePassword from "./Pages/PlayerChangePassword";
import PlayerForgotPassword from "./Pages/PlayerForgotPassword";
import PartyPopperEffect from "./components/PartyPopperEffect";
import Firework from "./components/Fireworks";
import SpecialGame from "./Pages/SpecialGame";
import ReferralSection from "./Pages/ReferAFreind";
import LandingNew from "./Pages/GameLevel";
import AllGame from "./Pages/AllGame";
import ContactUS from "./Pages/ContactUs";
import FloatingSocialIcons from "./Pages/SocialMedia";
import ShopPage from "./Pages/GiftShop";
import Home from "./pages_new/Home";
import HomeHeader from "./components_new/HomeHeader";
import Welcome from "./pages_new/Welcome";
import RapidRiddleSignIn from "./Pages/RapidRiddleSignin";
import RapidRiddleSignUp from "./Pages/RapidRiddleSignup";
import BackToBenchSignIn from "./Pages/BackToBenchSignIn";
import RapidRiddleLanding from "./Pages/RapidRiddleLanding";
import CountdownPage from "./components/CountDownPage";
import PlayDemoGame from "./Pages/PlayDemoGame";
import WaitingRoom from "./Pages/WaitingRoom";
import RapidRiddleGame from "./Pages/RapidRiddleGame";
import Scoreboard from "./components/Scoreboard";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import TimelessTiesSignIn from "./Pages/TimelessTiesSignIn";
import CrmLanding from "./Pages/CrmLanding";
import ReporterLoginPage from "./Pages/CrmReporterLogin";
import ReporterLandingPage from "./Pages/CrmReporterLanding";
import AdminCRMLogin from "./Pages/CrmAdminLogin";
import ProtectedRoute from "./components/ProtectedRoute";
import Profile from "./Pages/Profile";
import QuestionGenerator from "./Pages/QuestionGenerator";
import KrissKrossGame from "./Pages/KrissKross";

function App() {
  return (
    <Provider store={store}>
      <HelmetProvider>
        <BrowserRouter>
          <div style={{ height: "100%" }}>
            <Routes>
              <Route
                path="/"
                element={
                  localStorage.getItem("PlayerTocken") ? (
                    <PlayerLanding />
                  ) : (
                    <Landing />
                  )
                }
              />
              <Route path="/" element={<Landing />} />
              <Route path="/new-game" element={<NewGame1 />} />
              <Route path="/malayalam" element={<Malayalam />} />
              <Route path="/english" element={<English />} />
              <Route path="/crossword-creator" element={<CrosswordCreator />} />
              <Route path="/ans" element={<PlaceAnswerInGrid />} />
              <Route path="/player-signup" element={<PlayerSignUp />} />
              <Route path="/player-signin" element={<PlayerSignIn />} />
              <Route path="/creator-signup" element={<CreatorSignUp />} />
              <Route path="/creator-signin" element={<CreatorSignIn />} />
              <Route path="/play-game" element={<PlayGame />} />
              <Route path="/creator-landing" element={<CreatorLanding />} />
              <Route path="/release-soon" element={<NotRelese />} />
              <Route path="/creator-play-game" element={<CreatorPlayGame />} />
              <Route path="/theme" element={<Theme />} />
              <Route path="/game_name" element={<GameName />} />
              <Route path="/player-landing" element={<PlayerLanding />} />
              <Route
                path="/forgot-password"
                element={<PlayerForgotPassword />}
              />
              <Route
                path="/password-reset"
                element={<PlayerChangePassword />}
              />
              <Route path="/prty" element={<PartyPopperEffect />} />
              <Route path="/fire" element={<Firework />} />
              <Route path="/special-game" element={<SpecialGame />} />
              <Route path="/share" element={<ReferralSection />} />
              <Route path="/l-new" element={<LandingNew />} />
              <Route path="/all-game" element={<AllGame />} />
              <Route path="/contact-us" element={<ContactUS />} />
              <Route path="/social" element={<FloatingSocialIcons />} />
              <Route path="/gift" element={<ShopPage />} />
              <Route path="/welcome" element={<Welcome />} />
              <Route path="/home" element={<Home />} />
              <Route path="/home-header" element={<HomeHeader />} />
              <Route path="/rapid-signin" element={<RapidRiddleSignIn />} />
              <Route path="/rapid-signup" element={<RapidRiddleSignUp />} />
              <Route path="/profile" element={<Profile />} />
              <Route
                path="/back-to-bench-signin"
                element={<BackToBenchSignIn />}
              />
              <Route
                path="/rapid-riddle-landing"
                element={<RapidRiddleLanding />}
              />
              <Route path="/rapid-riddle-game" element={<RapidRiddleGame />} />
              <Route path="/waiting-room" element={<WaitingRoom />} />
              <Route path="/count-down" element={<CountdownPage />} />
              <Route path="/play-demo-game" element={<PlayDemoGame />} />
              <Route path="/score-game" element={<Scoreboard />} />
              <Route
                path="/timeless-ties-signin"
                element={<TimelessTiesSignIn />}
              />

              <Route path="/question-generator" element={<QuestionGenerator />} />
              <Route path="/kriss" element={<KrissKrossGame />} />

              {/* <Route element={<ProtectedRoute />}>
        <Route path="/crm" element={<CrmLanding />} />
      </Route> */}
              <Route path="/crm-login" element={<AdminCRMLogin />} />
              <Route path="/reporter-login" element={<ReporterLoginPage />} />
              {/* <Route element={<ProtectedRoute />}>
            <Route path="/reporter-landing" element={<ReporterLandingPage />} /> 
            </Route> */}
              <Route element={<ProtectedRoute />}>
                <Route path="/crm" element={<CrmLanding />} />
                <Route
                  path="/reporter-landing"
                  element={<ReporterLandingPage />}
                />
              </Route>
            </Routes>
          </div>
        </BrowserRouter>
      </HelmetProvider>
    </Provider>
  );
}

export default App;